// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"6437e12e","360":"0e9953bf","448":"a77b0aa1","953":"46203ada"}[chunkId] + ".chunk.css";
};